import { render, staticRenderFns } from "./HandbookEdit.vue?vue&type=template&id=4b1861a6&scoped=true"
import script from "./HandbookEdit.vue?vue&type=script&lang=js"
export * from "./HandbookEdit.vue?vue&type=script&lang=js"
import style0 from "./HandbookEdit.vue?vue&type=style&index=0&id=4b1861a6&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1861a6",
  null
  
)

export default component.exports